type Props = {
    children?: React.ReactNode;
    classes?: string;
    background?: string;
}

const AlertBox = (props: Props) => {
    const { children, classes, background = "danger" } = props;

    return (
        <div className={`alert alert-${background}  text-start ${classes}`} role="alert">
            {children}
        </div>
    )
}

export default AlertBox;